import { type SqlString, sql } from "../SqlString";
import { type SqliteTableDef } from "../schema";

/**
 * Creates a table specified by the desired SQLite table definition.
 */
export function createTableSql(tableDef: SqliteTableDef, ifNotExists: boolean = false) {
	const { tableName, columns } = tableDef;

	const columnString = columns.map((c) => {
		const name = sql.id(c.name);
		const type = c.type ? sql.lit(c.type) : undefined;
		const nullable = c.nullable === false ? sql.lit("NOT NULL") : undefined;
		const primaryKey = c.primaryKey ? sql.lit("PRIMARY KEY") : undefined;
		const unique = c.unique ? sql.lit("UNIQUE") : undefined;
		const defaultValue = c.defaultValue ? sql`DEFAULT ${c.defaultValue}` : undefined;

		const components = [name, type, nullable, primaryKey, unique, defaultValue].filter(
			(x) => x !== undefined
		);
		return sql.join(components, " ");
	});

	let createTableSql: SqlString;
	if (ifNotExists) {
		createTableSql = sql`CREATE TABLE IF NOT EXISTS ${sql.id(tableName)} (
	${sql.join(columnString, ",\n	")}
)`;
	} else {
		createTableSql = sql`CREATE TABLE ${sql.id(tableName)} (
	${sql.join(columnString, ",\n	")}
)`;
	}

	return createTableSql;
}
